<template>
  <div id="tickets_page">
    <div class="container">
      <app-tb-tickets />
      <app-tb-history />
    </div>
    <offer-use-open-id />
  </div>
</template>

<script>
  import Tickets from './tickets'
  import Operations from './operations'
  import OfferUseOpenId from './offer-use-open-id/index.vue'
  import Store from '../../store'

  export default {
    components: {
      'app-tb-tickets': Tickets,
      'app-tb-history': Operations,
      'offer-use-open-id': OfferUseOpenId
    },
    created: function () {
      Store.dispatch('getCurrentOrders', () => {
        Store.dispatch('getHistoryOrders', true)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// wrapper.vue?5914d418